export const STORAGE_ID_TOKEN_KEY = 'dashboard.idToken'

// Transient. To support "magic link".
export const STORAGE_SIGNIN_KEY = 'signIn.user'
export const STORAGE_PREVIOUS_PAGE_KEY = 'signIn.previousPage'
